import { flashErrorMessage } from 'redux-flash';
import * as api from 'api/cart';
import defineTypes from 'helpers/defineTypes';

// Action Types
const Types = defineTypes('mt/carts', [
  'CREATE_START',
  'CREATE_COMPLETED',
  'CREATE_FAILED',
  'FETCH_START',
  'FETCH_COMPLETED',
  'FETCH_FAILED',
  'UPDATE_START',
  'UPDATE_COMPLETED',
  'UPDATE_FAILED',
  'DELETE_ITEM_START',
  'DELETE_ITEM_COMPLETED',
  'DELETE_ITEM_FAILED',
]);

// Reducer
const initialState = {
  data: { cartItems: [], currency: 'CAD' },
  errors: [],
  isLoading: false,
  isOpen: false,
  success: true,
  expired: false,
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_START:
      return { ...state, isLoading: true };
    case Types.CREATE_COMPLETED:
      return {
        ...state,
        isLoaded: true,
        data: action.payload,
        isLoading: false,
      };
    case Types.CREATE_FAILED:
      return {
        ...state,
        isLoaded: false,
        error: action.payload,
        isLoading: false,
      };
    case Types.FETCH_START:
      return { ...state, isLoading: true };
    case Types.FETCH_COMPLETED:
      return {
        ...state,
        isLoaded: true,
        data: action.payload,
        isLoading: false,
      };
    case Types.FETCH_FAILED:
      return {
        ...state,
        isLoaded: false,
        error: action.payload,
        isLoading: false,
      };
    case Types.UPDATE_START:
      return { ...state, isLoading: true };

    case Types.UPDATE_COMPLETED:
      return { ...state, data: action.payload, isLoading: false };

    case Types.UPDATE_FAILED:
      return { ...state, errors: action.payload, isLoading: false };

    case Types.DELETE_ITEM_START:
      return { ...state };

    case Types.DELETE_ITEM_COMPLETED:
      return { ...state, data: action.payload };

    case Types.DELETE_ITEM_FAILED:
      return { ...state };

    case Types.PURCHASE_COMPLETE:
      if (action.payload.success) return initialState;
      return {
        ...state,
        success: action.payload.success,
        marketerSessionExpired: action.payload.marketerSessionExpired,
        message: action.payload.message,
      };

    case Types.UPDATE_SOURCE:
      return { ...state, source: action.payload };

    default:
      return state;
  }
};

export const createCart = () => async dispatch => {
  dispatch({ type: Types.CREATE_START });
  try {
    const data = await api.createCart();
    dispatch({ type: Types.CREATE_COMPLETED, payload: data });
  } catch (error) {
    dispatch({ type: Types.CREATE_FAILED, payload: { error } });
  }
};

// Action Creators
export const fetchCart = id => async dispatch => {
  dispatch({ type: Types.FETCH_START });
  try {
    const data = await api.fetchCart(id);
    dispatch({ type: Types.FETCH_COMPLETED, payload: data });
  } catch (error) {
    dispatch({ type: Types.FETCH_FAILED, payload: { error } });
  }
};

export const addItem = (id, lineItem) => async dispatch => {
  dispatch({ type: Types.UPDATE_START });

  try {
    const data = await api.addCartItem(id, lineItem);
    if (data.errors) {
      dispatch({ type: Types.UPDATE_FAILED, payload: data.errors });
      dispatch(flashErrorMessage(data.errors.join('')));
    } else {
      dispatch({ type: Types.UPDATE_COMPLETED, payload: data });
      dispatch({ type: `mt/ui/TOGGLE_CART_MODAL` });
    }
  } catch (error) {
    dispatch({ type: Types.UPDATE_FAILED, payload: { error } });
    dispatch(flashErrorMessage(error));
  }
};

export const updateItem = (id, lineItem) => async dispatch => {
  dispatch({ type: Types.UPDATE_START });

  try {
    const data = await api.updateCartItem(id, lineItem);
    if (data.errors) {
      dispatch({ type: Types.UPDATE_FAILED, payload: data.errors });
    } else {
      dispatch({ type: Types.UPDATE_COMPLETED, payload: data });
    }
  } catch (error) {
    dispatch({ type: Types.UPDATE_FAILED, payload: { error } });
  }
};

export const deleteItem = (id, itemId) => async dispatch => {
  dispatch({ type: Types.DELETE_ITEM_START });
  try {
    const data = await api.deleteCartItem(id, itemId);
    dispatch({ type: Types.DELETE_ITEM_COMPLETED, payload: data });
  } catch (error) {
    dispatch({ type: Types.DELETE_ITEM_FAILED });
  }
};

// Selectors
export const getTotalQuantity = state => {
  try {
    return state.cart.data.cartItems
      .map(cartItem => cartItem.quantity)
      .reduce((acc, value) => acc + value, 0);
  } catch (error) {
    return 0;
  }
};

export const getCartItems = state => state.cart.data.cartItems;

export const getCartSubtotal = state => state.cart.data.subtotal;

export const getCartCurrency = state => state.cart.data.currency.toLowerCase();



// WEBPACK FOOTER //
// ./src/ducks/cart.js